module.exports = __webpack_public_path__ + "img/link_ghlgw.fd31f269.jpg";